// extracted by mini-css-extract-plugin
export default {"buttonCount":"F_GHPeJ6","_withBrackets":"I5HO2ihm"};